module.exports = __webpack_public_path__ + "Flag-583.6b9d9c9cac8ebba54316991cc8c84e7b.svg";